export default {"src":"/_next/static/media/uptrend-2.9cbce3a4.svg","height":85,"width":126,"blurWidth":0,"blurHeight":0};